import { Fragment } from "react";

import MktLandingPageConcernCard from "@/components/molecules/LandingPageMolecules/MktLandingPageConcernCard/MktLandingPageConcernCard";
import { concerns } from "src/models/landing/concerns/concerns.model";

import * as S from "./MktLandingPageConcernsOraganism.style";

export default function MktLandingPageConcernsOraganism() {
  return (
    <S.Wrapper>
      <S.Title>
        <>
          이런 고민이 있는 마케터에게
          <br />꼭 필요한 커리큘럼입니다.
        </>

        <br />
      </S.Title>
      <S.Cards>
        {concerns.map((concern) => (
          <Fragment key={concern.marketerType}>
            <MktLandingPageConcernCard {...concern} />
          </Fragment>
        ))}
      </S.Cards>
    </S.Wrapper>
  );
}
